import Logger from '../../../utils/logger';

export default class MakeReservationResponse {
  constructor(json: any) {
    Logger.log(json);
  }
}
